import {
  GET_OPERATOR,
  SAVE_PLAN_INFOS,
  SET_DESTINATION_PATH,
  GET_HEALTH_INSURANCE_PLANS,
} from "./selectHealthInsuranceConstants";

import { apiIsa, authToken } from "../../../core/services/api";
import { HealthInsurancePlanProps } from "../selectHealthInsuranceInterface";

export const setDestinationPath = (data: any) => {
  return (dispatch: any) => {
    dispatch({ type: SET_DESTINATION_PATH, data });
  };
};

export const savePlanInfos = (data: any) => {
  return (dispatch: any) => {
    dispatch({ type: SAVE_PLAN_INFOS, data });
  };
};

const getOperatorEnd: any = (dispatch: any, data: any) => {
  dispatch({ type: GET_OPERATOR, data });
};

export const getOperator = (callback: any) => {
  const partnerInfo = JSON.parse(localStorage.getItem("partnerInfo") ?? "{}");

  // Verifica se partnerInfo.id existe e se é uma string válida
  const partnerIdQuery =
    typeof partnerInfo?.id === "string" && partnerInfo?.id.trim()
      ? `&partnerId=${partnerInfo?.id}`
      : "";

  return (dispatch: any) => {
    apiIsa
      .get(`/operator?active=${true}${partnerIdQuery}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${authToken}`,
        },
      })
      .then((responseJson) => {
        getOperatorEnd(dispatch, responseJson?.data);
        callback(responseJson?.data);
      })
      .catch((err) => {});
  };
};

const getHealthInsurancePlansEnd: any = (
  dispatch: any,
  data: HealthInsurancePlanProps[]
) => {
  dispatch({ type: GET_HEALTH_INSURANCE_PLANS, data });
};

export const getHealthInsurancePlans = (
  operatorId: string,
  callback?: (plans: HealthInsurancePlanProps[]) => void
) => {
  return (dispatch: any) => {
    apiIsa
      .get(`/healthInsurance?operatorId=${operatorId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${authToken}`,
        },
      })
      .then((responseJson) => {
        const plans = responseJson?.data || [];
        getHealthInsurancePlansEnd(dispatch, plans);
        if (callback) callback(plans);
      })
      .catch((err) => {
        console.error("Erro ao buscar planos de saúde:", err);
        getHealthInsurancePlansEnd(dispatch, []);
        if (callback) callback([]);
      });
  };
};
